<script lang="ts" setup></script>

<template>
  <UiButton as="a" href="/auth/sign-up" variant="outline">
    {{ $t('register') }}
  </UiButton>
</template>

<style scoped></style>
